import { type ComboboxItem } from "@mantine/core";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { type ILink } from "src/interfaces";
import { ButtonsWrapper } from "src/styled";

import AddCheckListButton from "./AddCheckListButton";
import { useChecklistsContext } from "./CheckListsContext";
import { CheckListType } from "./CheckLists.types";
import LocalSearch from "../../../../shared/LocalSearch/LocalSearch";

const CheckListsHeader = () => {
  const {
    logbooks,
    defaultChecklists,
    setChecklists,
    resetSearch,
    setResetSearch,
  } = useChecklistsContext();
  const { lbid, collectionId } = useParams();

  const customLastLinks = useMemo((): ILink[] | undefined => {
    if (collectionId && !lbid) {
      const collection = logbooks.find(el => el.value === collectionId);
      if (collection) {
        return [{ title: collection.label, href: "." }];
      }
    }

    if (!lbid) return undefined;

    const logbook = logbooks.find(el => el.value === lbid);
    if (!logbook) return undefined;

    if (collectionId) {
      const collection = logbooks.find(el => el.value === collectionId);
      if (collection) {
        return [
          {
            title: collection.label,
            href: `../collection/${collectionId}`,
          },
          { title: logbook.label, href: "." },
        ];
      }
    }

    const group = (logbook as ComboboxItem & { group?: string }).group;
    if (group && group !== logbook.label) {
      const collection = logbooks.find(
        el => el.label === group && el.group === group,
      );
      if (collection) {
        return [
          {
            title: collection.label,
            href: `../collection/${collection.value}`,
          },
          { title: logbook.label, href: "." },
        ];
      }
    }

    return [{ title: logbook.label, href: "." }];
  }, [logbooks, lbid, collectionId]);

  return (
    <Breadcrumbs border={false} customLastLinks={customLastLinks}>
      <ButtonsWrapper>
        {lbid && (
          <LocalSearch
            defaultData={defaultChecklists}
            setData={setChecklists}
            searchByProperty="name"
            resetSearch={resetSearch}
            setResetSearch={setResetSearch}
          />
        )}
        <AddCheckListButton title="Add Group +" type={CheckListType.Group} />
        <AddCheckListButton
          title="Add Checklist +"
          type={CheckListType.Single}
        />
      </ButtonsWrapper>
    </Breadcrumbs>
  );
};

export default CheckListsHeader;
